import { devtools } from "zustand/middleware";
import produce from "immer";
import create, { State, StateCreator } from "zustand";
import {
  layoutManagementStore,
  LayoutManagementStore,
} from "./layoutManagementStore";
import isDev from "../utils/isDev";

// Immer middleware. Shortcuts the use of immer for immutable state management
const immer =
  <T extends State>(config: StateCreator<T>): StateCreator<T> =>
  (set, get, api) =>
    config(
      (partial, replace) => {
        const nextState =
          typeof partial === "function"
            ? produce(partial as (state: T) => T)
            : (partial as T);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return set(nextState as any, replace);
      },
      get,
      api
    );

export const useLayoutManagementStore = !isDev()
  ? create<LayoutManagementStore>(immer(layoutManagementStore))
  : create<LayoutManagementStore>(
      devtools(immer(layoutManagementStore), {
        name: "Layout Management Store",
      })
    );
